/**
 * dockedInset — the width of the panel docked at the window's end edge (the
 * Inspector), so the selection bar can centre beside it instead of under it
 * (Duro ActionBar `insetInlineEnd`). The host that docks the panel measures
 * it and publishes the width; 0 when nothing is docked.
 */
import { useSyncExternalStore } from "react";

let inset = 0;
const listeners = new Set<() => void>();

export function publishDockedInset(px: number): void {
  const next = Math.max(0, Math.round(px));
  if (next === inset) return;
  inset = next;
  for (const l of listeners) l();
}

function subscribe(cb: () => void): () => void {
  listeners.add(cb);
  return () => listeners.delete(cb);
}

export function useDockedInset(): number {
  return useSyncExternalStore(
    subscribe,
    () => inset,
    () => 0,
  );
}
